import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Payments from 'actions/Payments';
import { toastr } from 'react-redux-toastr'

export function* onCreateAccountRequest({ payload, cb }) {
  try {
    const res = yield axios.post(`/api/stripe/createAccountLink`, payload);
    if (res.data) {
      cb && cb(res.data);
    }
  } catch (e) {
    // yield put(Payments.onCreateAccountFailure({ message: e.toString(), error: e }));
    cb && cb({ error: e });
  }
}

export function* onCheckAccountCreationRequest({ payload, cb }) {
  try {
    const res = yield axios.post(`/api/stripe/checkAccountCreation`, payload);
    cb && cb(res.data);
  } catch (e) {
    console.log('onCheckAccountCreationRequest error', e)
    // yield put(Payments.onCheckAccountCreationFailure({ message: e.toString(), error: e }));
    cb && cb({ error: e });
  }
}

export function* onGetPaymentReportsListRequest({ payload, cb }) {
  const { hitClubId, orderBy, orderDirection, page, size, q } = payload;
 
  try {
    const rs = yield axios.get(`/api/hitPayments/${hitClubId}/paymentReports?page=${page || 0}&size=${size || 10}${!!q ? `&q=${q}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    yield put(Payments.onGetPaymentReportsListSuccess({ data: rs.data, hitClubId: payload.hitClubId } || {}));
    cb && cb(res.data);
  } catch (e) {
    console.log('onGetPaymentReportsListRequest error', e)
    yield put(Payments.onGetPaymentReportsListFailure({ message: e.toString(), error: e }));
    cb && cb({ error: e });
  }
}

export function* onGetPaymentEventsListRequest({ payload, cb }) {
  const { hitClubId, orderBy, orderDirection, page, size, q } = payload;
 
  try {
    const rs = yield axios.get(`/api/hitPayments/hitClub/${hitClubId}/events?page=${page || 0}&size=${size || 10}${!!q ? `&q=${q}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    yield put(Payments.onGetPaymentEventsListSuccess({ data: rs.data, hitClubId: payload.hitClubId } || {}));
    cb && cb(res.data);
  } catch (e) {
    console.log('onGetPaymentEventsListDebouncedFailure error', e)
    yield put(Payments.onGetPaymentEventsListFailure({ message: e.toString(), error: e }));
    cb && cb({ error: e });
  }
}